/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S1_Label_AdresInputs */

const tr_onbilgi_s1_label_adres = /** @type {(inputs: Onbilgi_S1_Label_AdresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adres:`)
};

const en_onbilgi_s1_label_adres = /** @type {(inputs: Onbilgi_S1_Label_AdresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address:`)
};

const de_onbilgi_s1_label_adres = /** @type {(inputs: Onbilgi_S1_Label_AdresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse:`)
};

const ru_onbilgi_s1_label_adres = /** @type {(inputs: Onbilgi_S1_Label_AdresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адрес:`)
};

/**
* | output |
* | --- |
* | "Address:" |
*
* @param {Onbilgi_S1_Label_AdresInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s1_label_adres = /** @type {((inputs?: Onbilgi_S1_Label_AdresInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S1_Label_AdresInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s1_label_adres(inputs)
	if (locale === "de") return de_onbilgi_s1_label_adres(inputs)
	if (locale === "ru") return ru_onbilgi_s1_label_adres(inputs)
	return tr_onbilgi_s1_label_adres(inputs)
});